var checkIfItemIsInView = function checkIfItemIsInView(elem) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    fullObject: false
  };
  var scroll = window.scrollY || window.pageYOffset;
  if (elem &&
  // Check if DOMElement is visible in DOM
  !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)) {
    var boundsTop = elem.getBoundingClientRect().top + scroll;
    var viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight
    };
    var bounds = {
      top: boundsTop,
      bottom: boundsTop + elem.clientHeight
    };
    if (options.fullObject) {
      return bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom || bounds.top <= viewport.bottom && bounds.top >= viewport.top;
    }
    return bounds.bottom >= viewport.top && bounds.top <= viewport.bottom;
  }
  return false;
};
export default checkIfItemIsInView;